import React from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { readableProjectUnion } from 'shared/utils/room-shared';
import { useStyles } from '../Project.styles';

type Props = {
  data: ICastingRoleAttributes | undefined;
};

const Head: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  if (data === undefined) return <React.Fragment />;
  return (
    <div>
      <CustomTypography fontSize={25}>{data?.project.name || '–'}</CustomTypography>
      <div className={classes.miniRow}>
        <CustomTypography fontSize={13} fontWeight={600}>
          Type:
        </CustomTypography>
        <CustomTypography fontSize={13}>{data?.project.project_type || '–'}</CustomTypography>
        <CustomTypography fontSize={13}>|</CustomTypography>
        <CustomTypography fontSize={13} fontWeight={600}>
          Project Union:
        </CustomTypography>
        <CustomTypography fontSize={13}>Project Union:</CustomTypography>
        <CustomTypography fontSize={13} color="mainGray">
          {data?.project.union?.toLowerCase() === 'non union'
            ? 'Non Union'
            : data?.project.union
              ? readableProjectUnion(data.project.union)
              : '–'}
        </CustomTypography>
        <CustomTypography fontSize={13}>|</CustomTypography>
        <CustomTypography fontSize={13} fontWeight={600}>
          Project Rate:
        </CustomTypography>
        <CustomTypography fontSize={13}>{data?.project.rate || '–'}</CustomTypography>
      </div>
    </div>
  );
};

export default Head;
